export default `
<section>
  <h2>JURIIDILINE TEATIS
  </h2>
  <p>InnoCAPE (Tööstusharu 4: innovatsioonikeskkonna ümberkujundamine avalike teenuseosutajate parema suutlikkuse kaudu)
    on Interregi BSR programmi toetatud projekt, mis haldab veebisaite domeeni *
    <a target="_blank" href="https://innocape.eu" rel="noopener noreferrer">.innocape.eu
    </a> all.
  </p>
  <section>
    <h3>Veebilehtede vastutav töötleja ja teie isikuandmete töötlemine
    </h3>
    <p>Sunrise Valley teadus- ja tehnoloogiapark
    </p>
    <p>Ettevõtte registrikood Leedu äriregistris: 3126224832
    </p>
    <p>Aadress: Saulėtekio al. 15, LT-10224 Vilnius
    </p>
    <p>Veebipõhine leping:
      <a target="_blank" href="https://ssmtp.lt/en/contacts/" rel="noopener noreferrer">https://ssmtp.lt/en/contacts/
      </a>
    </p>
    <p>Veebilehe www.innocape.eu suhtes kohaldatakse Leedu õigusakte.
    </p>
  </section>
  <section>
    <h3>Toimetus
    </h3>
    <p>Veebilehtede sisu loob InnoCAPE'i projektipartnerite teavitusrühm:
      <a target="_blank" href="https://innocape.eu/#partners" rel="noopener noreferrer">https://innocape.eu/#partners
      </a>
    </p>
  </section>
  <section>
    <h3>Autoriõigus
    </h3>
    <p>© InnoCAPE, 2020
    </p>
    <p>Piltide, videote ja muu sisu reprodutseerimine on lubatud mitteärilistel eesmärkidel, tingimusel et viidatud on
      allikale, kui pole sätestatud teisiti. Kui teksti ja multimeediumi (heli, pildid, tarkvara jms) kujul oleva info
      reprodutseerimiseks või kasutamiseks on vaja eelnevalt taotleda luba, tühistab see luba ülalnimetatud üldsõnalise
      loa ja osutab selgelt sellega kaasnevatele kasutuspiirangutele.
    </p>
  </section>
  <section>
    <h3>Väline sisu
    </h3>
    <p>Meie veebileht sisaldab mitmesuguseid väliste veebilehtede hüperlinke ja lisatud sotsiaalmeediavooge. InnoCAPE ei
      vastuta väliste veebilehtede ja sotsiaalmeediakontode sisu eest, mida InnoCAPE'i toimetus ei halda.
    </p>
  </section>
  <section>
    <h3>Projekti veebilehed
    </h3>
    <p>Meie veebilehel on mitu üksikut projekti mikrosaiti. Nende veebilehtede sisu eest vastutab InnoCAPE'i projekti
      juhtiv partner –
      <a target="_blank" href="https://ssmtp.lt/en" rel="noopener noreferrer">Sunrise Valley teadus &amp; ja
        tehnoloogiapark
      </a>.
    </p>
  </section>
  <section>
    <h3>Hostimine
    </h3>
    <p>Veebilehe
      <a target="_blank" href="https://www.innocape.eu" rel="noopener noreferrer">www.innocape.eu
      </a> haldaja on Telia Lietuva AB, Vilnius, Leedu
      <a target="_blank" href="https://www.hostex.lt" rel="noopener noreferrer">www.hostex.lt
      </a>). Veebilehe
      <a target="_blank" href="https://dma.innocape.eu" rel="noopener noreferrer">dma.innocape.eu
      </a> (DMA) haldaja on SIA CUBE Systems, Riia, Läti (
      <a target="_blank" href="https://www.cubesystems.lv" rel="noopener noreferrer">www.cubesystems.lv
      </a>).
      <a target="_blank" href="https://www.cubesystems.lv" rel="noopener noreferrer">
      </a>Veebilehe
      <a target="_blank" href="https://cmap.innocape.eu" rel="noopener noreferrer">cmap.innocape.eu
      </a> (CMAP) haldaja on SIA Gstream, Riia, Läti (
      <a target="_blank" href="https://www.easyhosting.lv" rel="noopener noreferrer">www.easyhosting.lv
      </a>).
    </p>
  </section>
</section>
<section>
  <h2>PRIVAATSUSEESKIRI
  </h2>
  <p>Käesolev privaatsuseeskiri kohaldub ainult meie veebilehe ja mikrosaitide (alamveebilehtede) osas. Kui klõpsate
    mõne muu veebilehe lingil, peaksite tutvuma nende privaatsuseeskirjaga.
  </p>
  <p>InnoCAPE suhtub isikuandmete kaitsesse väga tõsiselt. Anname endast parima, et töödelda teie isikuandmeid kooskõlas
    <a target="_blank" href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32016R0679"
      rel="noopener noreferrer">isikuandmete kaitse üldmäärusega
    </a> Käesolev privaatsuseeskiri selgitab, kuidas me kasutame teie isikuandmeid, mida kogume teilt selle käigus, kui
    suhestute meie projektiga, näiteks kasutades meie veebilehte, liitudes meie üritustega või rakendades
    projektipartnerite loodud veebitööriistu.
  </p>
  <p>InnoCAPE kogub isikuandmeid nendelt, kes kasutavad meie digiküpsuse hindamise (DMA) ja kompetentsikaardi (CMAP)
    jaoks mõeldud veebipõhiseid tööriistu ja veebilehti, ning töötleb neid nõuetekohase hoolsusega kooskõlas kõigi
    kohaldatavate nõuetega, mis on kehtestatud Leedu Vabariigi isikuandmete kaitse õigusaktide ja muude seadustega, mis
    reguleerivad isikuandmete haldamist ning kaitset.
  </p>
  <section>
    <h3>i) Töödeldud isikuandmed ja andmeallikad&lt;
    </h3>
    <p>InnoCAPE kogub oma kasutajatelt järgnevat teavet: i) kasutajaandmed, ja ii) tehnilised andmed. Kuigi tehnilisi
      andmeid ei kasutata üldjuhul teie isiku tuvastamiseks, võib teie isik olla mõnikord nende põhjal siiski
      tuvastatav. Sellisel juhul võib kehtivate seaduste kohaselt lugeda tehnilisi andmeid samuti isikuandmeteks.
    </p>
    <p>Me kogume DMA või CMAP kaudu ning töötleme meie liikmete ja külastajate kohta järgmisi kasutajaandmeid: i) ees-
      ja perekonnanimi, ii) aadress, iii) telefoninumber, iv) e-posti aadress, v) teie asukoht meie teenuste kasutamise
      ajal, vi) haridusasutus või erioskused töökohas, (vii) ettevõtte andmed (kirjeldus, veebiaadress,
      sotsiaalmeedialingid jms).
    </p>
    <p>InnoCAPE kogub kasutajaandmeid meie liikmete ja külastajate kohta mitmel viisil, sealhulgas meie teenuste või
      veebipõhiste tööriistade (nt DMA ja CMAP) kasutajaks registreerimise, uudiskirja tellimise, mõnele meie üritusele
      registreerimise või vormi täitmise kaudu.
    </p>
    <p>InnoCAPE ja/või meie volitatud kolmanda osapoole teenusepakkujad koguvad tehnilisi andmeid automaatselt, kui
      külastate või kasutate meie teenuseid või veebilehti. Tehnilised andmed võivad sisaldada veebilehitseja nime,
      kasutatava arvuti või seadme tüüpi, veebilehel veedetud aega, teenuste kasutamist, külastuste kellaaega ja
      kuupäeva, surfamisharjumusi, IP-aadressi, operatsioonisüsteemi ning muud sarnast tehnilist teavet.
    </p>
    <p>InnoCAPE'i DMA ja CMAP veebilehtede külastamisel (sh küpsiste, Google Tagsi, Analyticsi jms kasutamisel) kasutame
      teabe kogumiseks ja salvestamiseks erinevaid tehnoloogiaid.
    </p>
    <p>üpsiste abil on meil võimalik arvutada meie veebilehti külastavate inimeste arvu ja jälgida veebilehe
      kasutusviisi. Samuti kasutame küpsiseid, mis muudavad veebilehe kasutamise teie jaoks hõlpsamaks, näiteks pidades
      meeles kasutajanimesid, salasõnu ja (keele) eelistusi. Lisaks kasutame ka jälitus- ja analüütilisi küpsiseid, et
      näha, kui hästi kasutajad meie teenuseid vastu võtavad.
    </p>
    <p>Teil on võimalik seadistada oma veebilehitseja selliselt, et see keelaks küpsiste kasutamise või teavitaks teid
      küpsiste saatmisest. Sellisel juhul palume arvesse võtta, et mõned meie veebilehe ja teenuste osad ei pruugi
      korralikult töötada. Lisateavet küpsiste ja nende kustutamise kohta leiate veebilehelt
      <a target="_blank" href="https://www.allaboutcookies.org" rel="noopener noreferrer">www.allaboutcookies.org
      </a>.
    </p>
    <p>Meie veebileht kasutab Google Analyticsit ja teisi veebianalüütika teenuseid (nt Google Tag Manager), et koostada
      külastuste kohta aruandeid, mis aitaksid meil oma veebilehte ja teenuseid parendada. Ülevaate saamiseks Google
      Analyticsi kohta külastage veebilehte
      <a target="_blank" href="https://www.google.com/analytics/"
        rel="noopener noreferrer">http://www.google.com/analytics/
      </a>. Ülevaate saamiseks Google Tag Manageri kohta külastage veebilehte
      <a target="_blank" href="https://support.google.com/tagmanager/answer/6102821?hl=en"
        rel="noopener noreferrer">https://support.google.com/tagmanager/answer/6102821?hl=en
      </a>
    </p>
  </section>
  <section>
    <h3>ii) Teie isikuandmete töötlemise eesmärgid ja õiguslik alus
    </h3>
    <p>Teie isikuandmete töötlemisel InnoCAPE'i poolt on mitu eesmärki:
    </p>
    <p>Meie teenuste osutamiseks ja teiega sõlmitud lepingu täitmiseks töötleb InnoCAPE teie isikuandmeid eelkõike
      selleks, et saaksime teile oma teenuseid pakkuda. See hõlmab selliste andmete töötlemist, mis on saadud
      digiküpsuse hindamise veebipõhise tööriista kasutamise kaudu ebaisikulisel ja koondatud kujul, et analüüsida
      digiteerimise olekut erinevates tööstusharudes ja geograafilistes piirkondades. Kasutame neid andmeid ka teiega
      ühenduse võtmiseks, kui olete selleks soovi avaldanud, et saaksime pärast digiküpsuse hindamist pakkuda teile
      täiendavat abi.
    </p>
    <p>InnoCAPE töötleb teie isikuandmeid kliendisuhtluse osana, et võtta teiega meie teenuste osas ühendust ning
      teavitada teid meie teenuste muudatustest. Samuti kasutatakse teie andmeid uuringute ja analüüside tegemiseks, et
      täiustada meie teenuseid ja veebilehte. Lisaks võime teatud juhtudel kasutada veebilehele sisestatud andmeid teile
      projektiga seotud teabe edastamiseks e-posti teel, kui olete meile selleks oma nõusoleku andnud.
    </p>
  </section>
  <section>
    <h3>iii) Andmete saajad
    </h3>
    <p>Jagame teie isikuandmeid InnoCAPE’i konsortsiumi ja INTERREG Euroopa Läänemere piirkonna programmi
      haldusasutuse/ühissekretariaadi organisatsiooni piires ainult siis ja nii palju kui see on mõistlikult vajalik
      meie teenuste osutamiseks ja arendamiseks ning projekti elluviimiseks.
    </p>
    <section>
      <h4>See on vajalik käesolevast isikuandmete kaitset käsitlevast avaldusest tulenevalt
      </h4>
      <p>uhul kui kolmandad osapooled vajavad oma teenuste osutamiseks juurdepääsu isikuandmetele, rakendab InnoCAPE
        asjakohaseid lepingulisi ja korralduslikke meetmeid, tagamaks teie andmete töötlemise eranditult käesolevas
        isikuandmete kaitset käsitlevas avalduses täpsustatud eesmärkidele vastavalt ning kooskõlas kõikide kohalduvate
        õigusaktide ja määrustega. Lisaks võime edastada teie isikuandmeid oma sidusettevõtetele või teistele
        usaldusväärsetele ettevõtetele või isikutele töötlemiseks meie asemel, vastavalt meie juhistele ning kooskõlas
        meie isikuandmete kaitset käsitleva avalduse ja teiste asjakohaste konfidentsiaalsus- ja turvameetmetega.
      </p>
    </section>
    <section>
      <h4>See on vajalik juriidilistel põhjustel
      </h4>
      <p>Võime jagada teie isikuandmeid kolmandate osapooltega väljaspool InnoCAPE'i, kui usume, et juurdepääs
        isikuandmetele ja nende kasutamine on mõistlikult vajalik, et: i) järgida kõiki kohalduvaid õigusakte, määrusi
        ja/või kohtumäärusi; ii) avastada, ära hoida või muul viisil tegeleda pettuste, turvalisuse või tehniliste
        probleemidega; ja/või iii) kaitsta InnoCAPE'i, meie kasutajate või avalikkuse huve, vara või turvalisust
        niivõrd, kui see on seadusega kooskõlas. Võimalusel teavitame teid sellisest töötlemisest.
      </p>
    </section>
  </section>
  <section>
    <h3>iv) Andmete säilitamise aeg
    </h3>
    <p>InnoCAPE ei säilita teie isikuandmeid kauem, kui on seadusega lubatud ja vajalik nende eesmärkide täitmiseks,
      milleks andmeid koguti. Säilitamise periood sõltub teabe olemusest ja töötlemise eesmärkidest. Seepärast võib
      maksimaalne säilitamise periood tehniliste andmete puhul kasutusotstarbest tulenevalt varieeruda, kuniks meie
      veebileht internetis avatud on. Me säilitame teie isikuandmeid teenuste osutamise kohta maksimaalselt viis aastat
      pärast projekti lõppu, milleks on DMA ja CMAP puhul oktoober 2021.
    </p>
  </section>
  <section>
    <h3>v) Teie õigused
    </h3>
    <section>
      <h4>Õigus oma andmetele ligi pääseda
      </h4>
      <p>InnoCAPE võimaldab teil ligi pääseda meie töödeldavatele isikuandmetele. See tähendab, et võite meiega ühendust
        võtta ja küsida teavet teie kohta kogutud ja töödeldud isikuandmete ning nende andmete kasutamise eesmärkide
        kohta.
      </p>
    </section>
    <section>
      <h4>Õigus oma andmeid parandada
      </h4>
      <p>Teil on õigus taotleda meiega ühendust võttes enda kohta kogutud valede/ebatäpsete, mittetäielike, aegunud või
        ebavajalike isikuandmete parandamist ja täiendamist.
      </p>
    </section>
    <section>
      <h4>Kõikide andmete kustutamise õigus
      </h4>
      <p>Samuti on teil õigus taotleda oma isikuandmete kustutamist meie süsteemidest. Tuleme sellistele soovidele
        vastu, välja arvatud juhul kui meil on olemas seaduslik alus andmeid mitte kustutada. Andmete kustutamise korral
        ei pruugi meil olla koheselt võimalik ära kustutada ka kõiki järelejäänud koopiaid aktiivsetest serveritest ja
        varusüsteemidest.
      </p>
    </section>
    <section>
      <h4>Õigus esitada vastuväiteid oma andmete konkreetset laadi kasutamisele
      </h4>
      <p>Võite esitada oma isikuandmete konkreetset laadi kasutamisele vastuväiteid, kui neid andmeid töödeldakse muudel
        eesmärkidel, kui see on vajalik meie teenuste osutamiseks või seadusest tuleneva kohustuse täitmiseks. Samuti
        võite esitada vastuväiteid oma isikuandmete edasisele töötlemisele, millele te eelnevalt nõusoleku olite andnud.
        Kui esitate vastuväite oma isikuandmete edasisele töötlemisele, võib see halvendada meie teenuste osutamise
        kvaliteeti.
      </p>
    </section>
    <section>
      <h4>Õigus taotleda oma isikuandmete töötlemise piiramist
      </h4>
      <p>Võite taotleda meilt oma isikuandmete konkreetset laadi töötlemise piiramist. Samas võib see halvendada meie
        teenuste osutamise kvaliteeti.
      </p>
    </section>
    <section>
      <h4>Õigus andmete teisaldatavusele
      </h4>
      <p>Teil on õigus taotleda, et saadaksime teile teie isikuandmed eesmärgiga edastada need mõnele teisele
        vastutavale töötlejale.
      </p>
    </section>
    <section>
      <h4>Kuidas oma õigusi kasutada?
      </h4>
      <p>Saate oma õigusi kasutada, saates meile ülaltoodud aadressidel kirja või e-kirja, milles olete ära märkinud oma
        nime, aadressi, telefoninumbri ja kehtiva isikut tõendava dokumendi koopia. Kui leiate, et meie isikuandmete
        töötlemine on vastuolus kohalduvate andmekaitsealaste õigusaktidega, võite esitada kaebuse kohalikule
        andmekaitsega tegelevale järelevalveasutusele.
      </p>
    </section>
  </section>
  <section>
    <h3>vi) Teabekaitse
    </h3>
    <p>Kasutame kõiki mõistlikke ja asjakohaseid turvameetmeid, et kaitsta meie valduses olevaid isikuandmeid InnoCAPE'i
      volitamata juurdepääsu, nende loata muutmise, avalikustamise või hävitamise eest. Meetmed hõlmavad vajaduse korral
      krüpteerimist, tulemüüre, turvaseadmeid ja juurdepääsuõiguste süsteeme. Kui turvameetmetest hoolimata peaks
      ilmnema turvarikkumine, millel võib olla teie privaatsusele negatiivne mõju, teavitame teid rikkumisest
      võimalikult kiiresti.
    </p>
  </section>
  <section>
    <h3>vii) Eeskirja muutmine
    </h3>
    <p>Privaatsuseeskiri avaldatakse eesti keeles ja seda võidakse aeg-ajalt muuta. Kehtiva versiooni leiate meie
      veebilehelt
      <a target="_blank" href="https://innocape.eu/privacy-policy/"
        rel="noopener noreferrer">https://innocape.eu/privacy-policy/
      </a>. Jätame endale õiguse käesolevat privaatsuseeskirja igal ajal muuta. Kõik muudatused avaldatakse meie
      kodulehel, et saaksite muudatustest teada. Käesolevat privaatsuseeskirja uuendati viimati 1. detsembril 2020.
    </p>
  </section>
</section>
<section>
  <h2>KUIDAS MEIEGA ÜHENDUST VÕTTA:
  </h2>
  <p>Sunrise Valley teadus- ja tehnoloogiapark
  </p>
  <p>Sauletekio ave 15, LT-10224 Vilnius [Leedu]
  </p>
  <p>Tel. + 370 640 56547
  </p>
  <p>E-post: info@innocape.eu
  </p>
</section>
`
